var map = {
	"./DefaultLoader": [
		"e711",
		"tournamentCover"
	],
	"./DefaultLoader.vue": [
		"e711",
		"tournamentCover"
	],
	"./ParticipantUserCardLoader": [
		"42b2",
		"tournamentCover"
	],
	"./ParticipantUserCardLoader.vue": [
		"42b2",
		"tournamentCover"
	],
	"./StageLoader": [
		"1a02",
		"tournamentCover"
	],
	"./StageLoader.vue": [
		"1a02",
		"tournamentCover"
	],
	"./StageSummaryLoader": [
		"f3cd",
		"tournamentCover"
	],
	"./StageSummaryLoader.vue": [
		"f3cd",
		"tournamentCover"
	],
	"./TournamentCardLoader": [
		"79c1",
		"tournamentCover"
	],
	"./TournamentCardLoader.vue": [
		"79c1",
		"tournamentCover"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "81d1";
module.exports = webpackAsyncContext;